<template>
  <b-modal id="saveCategoryModal" ref="saveCategoryModal" :modal-class="modal_class" centered hide-footer :lazy="true">
    <template #modal-title> {{ title }} </template><b-form @submit.prevent="onSubmit">
      <input type="hidden" v-model="category" id="category" />
      <input type="hidden" v-model="type" id="type" />
      <!-- {{ category }} , {{ type }} , {{ client_name }}, {{ title }},
      {{ action_type }} -->
      <b-row class="mt-3">
        <b-col md="12">
          <b-form-group :label="category == 'music_library'
              ? 'Playlist category title'
              : 'Category title'
            " label-for="category_title" :category_title="category_title" :label-class="form_label_class">
            <b-form-input id="category_title" :class="input_class" v-model="category_title"
              :category_title="category_title" required></b-form-input>
          </b-form-group> </b-col><b-col md="12">
          <b-form-group :label="category == 'music_library'
              ? 'Playlist Description (optional)'
              : 'Category Description (optional)'
            " label-for="category_description" :category_description="category_description"
            :label-class="form_label_class">
            <b-form-textarea id="category_description" :class="input_class" v-model="category_description"
              :category_description="category_description" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col> </b-row><b-row class="mt-4">
        <b-col>
          <b-button :variant="btn_variant_primary" class="btn-bumblebee float-right" :class="btn_submit_class"
            type="submit" v-if="!is_loading">
            Save
          </b-button>
          <b-button type="button" disabled :variant="btn_variant_primary" class="btn-bumblebee float-right"
            :class="btn_submit_class" v-else>
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import $ from "jquery";
import axios from "axios";

import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

export default {
  name: "SaveCategory",
  props: [
    "client_name",
    "category",
    "type",
    "title",
    "action_type",
    "category_id",
    "category_title",
    "category_description",
    "modal_class", "form_label_class", "input_class",
    "btn_variant_primary", "btn_submit_class","swal_confirm_button_class","swal_container_class" 
  ],
  data() {
    return {
      is_loading: false,
    };
  },

  mounted() {
    console.log(this.category, this.type, this.title, this.action_type);
    console.log(
      this.category_id,
      this.category_title,
      this.category_description
    );
  },
  computed: {
    _category_title: {
      get() {
        return this.category_title;
      },
      set(value) {
        console.log(value);
        this.$emit("update:category_title", value);
        console.log(this.category_title);
        console.log(this._category_title);
      },
    },
    _category_description: {
      get() {
        return this.category_description;
      },
      set(value) {
        console.log(value);
        this.$emit("update:category_description", value);
      },
    },
  },
  methods: {
    onSubmit(event) {
      console.log(event);
      console.log(this.category_title);
      console.log(this.category_description);
      console.log(this.category);
      console.log(this.type);

      let formData = new FormData();
      formData.append("client", this.client_name);
      formData.append("title", this.category_title);
      formData.append("description", this.category_description);
      formData.append("sub_library", this.type);
      formData.append("media_library", this.category);

      console.log(formData);

      this.is_loading = true;
      if (this.action_type == "add") {
        this.sendAddCategoryRequest(formData);
      } else if (this.action_type == "edit") {
        formData.append("id", this.category_id);
        this.sendEditCategoryRequest(formData);
      }
    },
    sendAddCategoryRequest(formData) {
      console.log("in send add cateogry request");
      axios
        .post("category/create", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.is_loading = false;
          let success_message = "Category is saved successfully"
          if (this.category == "music_library") {
            success_message = success_message.replace("Category", "Playlist").replace("category", "playlist")
          }

          this.$fire({
            // title: "Title",
            text: success_message,
            type: "success",
            // timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            this.is_loading = false;
            //reset form
            this.category_title = "";
            this.category_description = "";
            this.$bvModal.hide("saveCategoryModal");
            console.log(this.$parent.$parent);
            if (this.category == "video_library") {
              this.$parent.$parent.getMediaCategoryList();
            } else if (
              this.category == "meditation_library" &&
              this.type == "video"
            ) {
              console.log(this.$parent);
              this.$parent.$refs.videoCategoryListMed.getMediaCategoryList();
            } else if (
              this.category == "meditation_library" &&
              this.type == "audio"
            ) {
              console.log(this.$parent);
              this.$parent.$refs.audioCategoryListMed.getMediaCategoryList();
            }
            else if (
              this.category == "music_library"
            ) {
              console.log(this.$parent);
              this.$parent.$parent.getMediaCategoryList();
            }
          });
          // this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: "Sorry, error in saving category",
            type: "error",
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    sendEditCategoryRequest(formData) {
      console.log("in send edit category request");
      console.log(
        this.category_id,
        this.category_title,
        this.category_description
      );
      console.log(
        this.category_id,
        this._category_title,
        this._category_description
      );
      console.log(this.category, this.type, this.action_type);
      axios
        .post("category/update", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.is_loading = false;
          let success_message = "Category is updated successfully"
          if (this.category == "music_library") {
            success_message = success_message.replace("Category", "Playlist").replace("category", "playlist")
          }


          this.$fire({
            // title: "Title",
            text: success_message,
            type: "success",
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
            // timer: 3000,
          }).then((r) => {
            this.is_loading = false;
            //reset form
            this.category_title = "";
            this.category_description = "";
            this.$bvModal.hide("saveCategoryModal");
            console.log(this.$parent.$parent);
            if (this.category == "video_library") {
              this.$parent.$parent.getMediaCategoryList();
            } else if (
              this.category == "meditation_library" &&
              this.type == "video"
            ) {
              console.log(this.$parent);
              this.$parent.$refs.videoCategoryListMed.getMediaCategoryList();
            } else if (
              this.category == "meditation_library" &&
              this.type == "audio"
            ) {
              console.log(this.$parent);
              this.$parent.$refs.audioCategoryListMed.getMediaCategoryList();
            }
            else if (
              this.category == "music_library"
            ) {
              console.log(this.$parent);
              this.$parent.$parent.getMediaCategoryList();
            }
          });
          // this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: "Sorry, error in saving category",
            type: "error",
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/media_components/media/SaveCategory.vue